import React from 'react';

export default function BtnSmallDisabled({ children, ...restProps }) {
  return (
    <button {...restProps} className={`text-center bg-secondary-dark hover:border-2 hover:border-primary-dark hover:border-solid w-150 h-14 text-primary-white`}>{children}</button>
  );
}
